export default "__VITE_ASSET__Cbp87z0T__"